import { LazyOffersList } from '../LazyOffersList';
import { IComponentDefinition } from '../../../grapesJs/reactComponentsRegistry/types';
import { COMMON_COMPONENT_PROPS } from '../../../grapesJs/reactComponentsRegistry/const';

export const lazyOffersListComponent: IComponentDefinition = {
  ...COMMON_COMPONENT_PROPS,
  id: 'lazyOffersList',
  component: LazyOffersList,
  tagName: 'lazyofferslist',
  stylable: true,
  droppable: false,
  defaultAttributes: {
    url: '',
    oneLine: false,
    staticRegion: false,
    hideShowMoreButton: false,
  },
  traits: [
    {
      type: 'text',
      label: 'Url',
      name: 'url',
    },
    {
      type: 'checkbox',
      label: 'One line (desktop)',
      name: 'oneLine',
    },
    {
      type: 'checkbox',
      label: 'Static region',
      name: 'staticRegion',
    },
    {
      type: 'checkbox',
      label: 'Hide "Посмотреть ещё"',
      name: 'hideShowMoreButton',
    },
  ],
  block: {
    label: 'Lazy OffersList',
    category: 'Content',
    content: '<LazyOffersList url="" />',
  },
};
